import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["attrs", "classes", "size", "src", "color"],
  _excluded2 = ["width"];
import React from "react";
import { func, number, shape, string } from "prop-types";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./icon.css";
import myClasses from "./icon.module.scss";
var getIconColorStyle = color => "iconStyle_".concat(color);
var Icon = props => {
  // destructure `propClasses` to exclude it from `restProps`
  var {
      attrs,
      classes: propClasses,
      size,
      src: Component,
      color
    } = props,
    restProps = _objectWithoutProperties(props, _excluded);
  var _ref = attrs || {},
    {
      width
    } = _ref,
    restAttrs = _objectWithoutProperties(_ref, _excluded2);
  var classes = mergeClasses(myClasses, defaultClasses, propClasses);

  // const iconColor = classes[getIconColorStyle(color)];

  var iconColor = window.location.pathname === "/cookie-policy" || window.location.pathname === "/privacy" ? classes.iconStyle_red : classes.iconStyle_white;
  return /*#__PURE__*/React.createElement("span", _extends({
    className: classes.root
  }, restProps), /*#__PURE__*/React.createElement(Component, _extends({
    className: classes.icon && iconColor,
    size: size || width
  }, restAttrs)));
};
export default Icon;
Icon.propTypes = {
  attrs: shape({}),
  classes: shape({
    icon: string,
    root: string
  }),
  size: number,
  src: func,
  color: string
};
Icon.defaultProps = {
  color: "white"
};